<div class="pp-editor">
  @if (steps.length === 0) {
    <div class="pp-empty">No post-processing</div>
  }

  @for (step of steps; track $index; let i = $index) {
    <div class="pp-step">
      <div class="pp-step-header">
        <span class="pp-step-num">{{ i + 1 }}</span>
        <select class="form-select form-select-sm pp-type-select"
          [ngModel]="step.type"
          (ngModelChange)="onTypeChange(step, $event)">
          <option value="regex_extract">regex_extract</option>
          <option value="replace">replace</option>
          <option value="map_none_if">map_none_if</option>
          <option value="strip_affix">strip_affix</option>
        </select>
        <button type="button" class="btn btn-outline-secondary btn-xs"
          [disabled]="i === 0"
          (click)="moveUp(i)"
          title="Move up">↑</button>
        <button type="button" class="btn btn-outline-secondary btn-xs"
          [disabled]="i === steps.length - 1"
          (click)="moveDown(i)"
          title="Move down">↓</button>
        <button type="button" class="btn btn-outline-danger btn-xs"
          (click)="removeStep(i)"
          title="Remove step">×</button>
        <span class="pp-type-help"
          [matTooltip]="tooltipFor(step.type)"
          matTooltipPosition="right">?</span>
      </div>

      @if (step.type === 'regex_extract') {
        <div class="pp-fields">
          <div class="pp-field">
            <label class="pp-label">Pattern</label>
            <input type="text" class="form-control form-control-sm"
              [(ngModel)]="step.pattern"
              (ngModelChange)="schedulePreview()"
              placeholder="regex pattern">
          </div>
          <div class="pp-field pp-field-sm">
            <label class="pp-label">Capture group</label>
            <input type="number" class="form-control form-control-sm"
              [ngModel]="step.group ?? 1"
              (ngModelChange)="step.group = $event; schedulePreview()"
              min="0" step="1">
          </div>
        </div>
      }

      @if (step.type === 'replace') {
        <div class="pp-fields">
          <div class="pp-field">
            <label class="pp-label">Find</label>
            <input type="text" class="form-control form-control-sm"
              [(ngModel)]="step.old"
              (ngModelChange)="schedulePreview()"
              placeholder="substring to find">
          </div>
          <div class="pp-field">
            <label class="pp-label">Replace with</label>
            <input type="text" class="form-control form-control-sm"
              [(ngModel)]="step.new"
              (ngModelChange)="schedulePreview()"
              placeholder="empty = delete">
          </div>
        </div>
      }

      @if (step.type === 'map_none_if') {
        <div class="pp-fields">
          <div class="pp-field pp-field-full">
            <label class="pp-label">Treat as missing</label>
            <div class="pp-chips">
              @for (v of (step.values ?? []); track v; let vi = $index) {
                <span class="pp-chip">
                  {{ v }}
                  <button type="button" class="pp-chip-remove" (click)="removeValue(step, vi)">×</button>
                </span>
              }
              <input type="text" class="form-control form-control-sm pp-chip-input"
                [ngModel]="valuesInputs[i] ?? ''"
                (ngModelChange)="valuesInputs[i] = $event"
                (keydown)="onValuesKeydown($event, step, valuesInputs[i] ?? '', i)"
                placeholder="add value and press Enter">
              <button type="button" class="btn btn-outline-secondary btn-xs"
                (click)="addValue(step, valuesInputs[i] ?? '', i)">Add</button>
            </div>
          </div>
        </div>
      }

      @if (step.type === 'strip_affix') {
        <div class="pp-fields">
          <div class="pp-field">
            <label class="pp-label">Prefix</label>
            <input type="text" class="form-control form-control-sm"
              [(ngModel)]="step.prefix"
              (ngModelChange)="schedulePreview()"
              placeholder="prefix to remove">
          </div>
          <div class="pp-field">
            <label class="pp-label">Suffix</label>
            <input type="text" class="form-control form-control-sm"
              [(ngModel)]="step.suffix"
              (ngModelChange)="schedulePreview()"
              placeholder="suffix to remove">
          </div>
        </div>
      }

      @if (getWarning(step)) {
        <div class="pp-warning">⚠ {{ getWarning(step) }}</div>
      }
    </div>
  }

  <button type="button" class="btn btn-outline-primary btn-sm mt-2" (click)="addStep()">+ Add step</button>

  @if (steps.length > 0) {
    <div class="pp-preview">
      @if (previewPending > 0) {
        <span class="text-muted small">…</span>
      } @else {
        <table class="pp-preview-table">
          <thead>
            <tr>
              <th></th>
              <th>Raw</th>
              <th>Processed</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="pp-preview-page-label">Value from Extractor Search</td>
              <td><code class="pp-preview-value">{{ sel.extracted_value ?? '(none)' }}</code></td>
              <td>
                <code class="pp-preview-value" [class.pp-preview-null]="preview1Processed === null">
                  {{ preview1Processed ?? '(null / no match)' }}
                </code>
              </td>
            </tr>
            @if (pageSource2) {
              <tr>
                <td class="pp-preview-page-label">Value from Test</td>
                <td>
                  <code class="pp-preview-value" [class.pp-preview-null]="preview2Raw === null">
                    {{ preview2Raw ?? '(null / no match)' }}
                  </code>
                </td>
                <td>
                  <code class="pp-preview-value" [class.pp-preview-null]="preview2Processed === null">
                    {{ preview2Processed ?? '(null / no match)' }}
                  </code>
                </td>
              </tr>
            }
          </tbody>
        </table>
      }
    </div>
  }
</div>
